/* Prozone B2B – prozone.js
   Menu mobile, toggle des filtres catalogue, boutons quantité.
   Les anciens blocs .pz-variant-pill / .pz-gallery__thumb / .pz-variant-select
   ont été retirés : leurs sélecteurs n'existaient dans aucun template rendu
   (ils appartenaient au snippet mort pz-product-main.liquid). La sélection de
   variante et la galerie sont gérées par pz-product-detail.liquid. */
(function() {
  var hamburger = document.querySelector('.pz-hamburger');
  var drawer    = document.querySelector('.pz-drawer');
  if (hamburger && drawer) {
    var bg = drawer.querySelector('.pz-drawer__bg');
    var cl = drawer.querySelector('.pz-drawer__close');
    function open()  { drawer.classList.add('open'); document.body.style.overflow='hidden'; }
    function close() { drawer.classList.remove('open'); document.body.style.overflow=''; }
    hamburger.addEventListener('click', open);
    if (cl) cl.addEventListener('click', close);
    if (bg) bg.addEventListener('click', close);
  }
  var ft = document.querySelector('.pz-filters-toggle');
  var fp = document.querySelector('.pz-filters');
  if (ft && fp) ft.addEventListener('click', function(){ fp.classList.toggle('open'); });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pz-qty-btn');
    if (!btn) return;
    var wrap = btn.closest('.pz-qty-wrap');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var val = parseInt(input.value) || 1;
    var min = parseInt(input.min) || 1;
    if (btn.dataset.action === 'decrease' && val > min) input.value = val - 1;
    if (btn.dataset.action === 'increase') input.value = val + 1;
  });
})();
